module.exports = __webpack_public_path__ + "static/media/smartphone-text-wally.f51ae6eb.svg";